<template>
    <div class="lg:flex w-full" :class="$widgetUI=='NEW-UI' ? 'lg:h-[950px] relative':'lg:h-[800px] relative'">
        <template v-if="$widgetConfig.staticAudience">
            <div>
                <sidebar-static-audience/>
            </div>
        </template>
        <template v-else>
            <sidebar/>
        </template>
        <div :class="showfilter ? 'backdrop':''">
            <choose-filter/>
        </div>
        <div class="w-full bg-gray-100 grid-fake-leads" :class="$widgetUI=='NEW-UI' ? 'lg:w-[calc(100%-37%)] 2xl:w-[calc(100%-45%)] box-shadow':'lg:w-[calc(100%-300px)] 2xl:w-[calc(100%-465px)]' ">
            <box-leads/>

            <fake-leads/>
        </div>
        <template v-if="$widgetUI=='NEW-UI'">
            <div v-if="desktopTabActive" data-title="Adjust quantity or budget" data-intro='Adjust your quantity or budget to match the list size that meets your needs.' data-step="5" :class="moblieActive ? 'backdrop':''">
                <right-sidebar ></right-sidebar>
            </div>
            <div v-else :class="moblieActive ? 'backdrop':''">
                <right-sidebar ></right-sidebar>
            </div>
        </template>

        <portal selector="#widget-modal">
            <modal-cart/>
            <modal-autocomplete-tree/>
        </portal>
    </div>
</template>

<script>
import boxLeads from "./box-leads";
import fakeLeads from "./fake-leads";
import modalCart from "./modals/modal-cart";
import sidebar from "./sidebar";
import rightSidebar from "./right-sidebar";
import chooseFilter from "./choose-filters";
import introJS from 'intro.js';

import sidebarStaticAudience from "./sidebar-static-audience";
export default {
    components: {
        modalCart,
        fakeLeads,
        boxLeads,
        sidebar,
        sidebarStaticAudience,
        rightSidebar,
        chooseFilter,
        ModalAutocompleteTree: () => import("./modals/modal-autocomplete-tree")
    },
    data () {
        return {
            innerWidth: window.innerWidth,
            tabletActive:false,
            mobileTabActive:false,
            desktopTabActive:true,

        };
    },
    computed: {
        moblieActive() {
            return this.$store.state.widgetData.showRightbar;
        },
        showfilter(){
            return this.$store.state.widgetData.showfilter;
        },

    },
    methods:{
        getcheckDivec(){
            this.innerWidth = window.innerWidth;
            if(this.innerWidth  < 1024 && this.innerWidth  > 724 ){
                this.tabletActive=true;
                this.mobileTabActive=false;
                this.desktopTabActive=false;
            }
            else if (this.innerWidth < 724){
                this.tabletActive=false;
                this.mobileTabActive=true;
                this.desktopTabActive=false;
            }
            else{
                this.tabletActive=false;
                this.mobileTabActive=false;
                this.desktopTabActive=true;
            }
        }
    },
    mounted() {
        this.getcheckDivec();
        window.addEventListener('resize', () => {
            this.getcheckDivec();
        })
    }
};
</script>
